import React from "react";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { Plus } from "lucide-react";
import { useLang } from "../i18n/LangContext";

export const FAQ = () => {
  const { t } = useLang();
  const items = t("faq.items");

  return (
    <section
      id="faq"
      data-testid="section-faq"
      className="relative py-24 lg:py-32 bg-[#050505]"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-5"
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-primary-red" />
              <span className="text-[10px] font-bold uppercase tracking-[0.28em] text-zinc-400">
                {t("faq.eyebrow")}
              </span>
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-[1.05] tracking-tight">
              {t("faq.title")}
            </h2>
          </motion.div>

          <div className="lg:col-span-7">
            <Accordion type="single" collapsible className="w-full">
              {items.map((it, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="border-white/10"
                >
                  <AccordionTrigger className="text-left py-6 hover:no-underline [&>svg]:hidden group">
                    <div className="flex items-start justify-between w-full gap-6">
                      <span className="font-display text-base lg:text-xl font-semibold text-white pr-4 group-hover:text-primary-red transition-colors">
                        {it.q}
                      </span>
                      <Plus
                        size={22}
                        className="acc-icon text-primary-red shrink-0 mt-1"
                        strokeWidth={1.5}
                      />
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className="pb-8">
                    <p className="font-body text-sm lg:text-base text-zinc-400 leading-relaxed max-w-2xl">
                      {it.a}
                    </p>
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};
